// Order status helpers. Status values are the backend ItemsOrder.Status enum names.

export const ORDER_STEPS = ['CONFIRMED', 'PROCESSING', 'PACKAGED', 'SHIPPED', 'DELIVERED']

const TONES = {
    CONFIRMED: 'info',
    PROCESSING: 'info',
    PACKAGED: 'info',
    SHIPPED: 'accent',
    DELIVERED: 'success',
    CANCELLED: 'danger',
    REQUEST_RETURN: 'warning',
    RETURNED: 'neutral'
}

// Numeric status codes used by the admin APIs (ItemsOrder.Status.value).
export const STATUS_BY_CODE = {
    1: 'CONFIRMED',
    2: 'PROCESSING',
    3: 'PACKAGED',
    4: 'SHIPPED',
    5: 'DELIVERED',
    6: 'CANCELLED',
    7: 'REQUEST_RETURN',
    8: 'RETURNED'
}

export const statusFromCode = (code) => STATUS_BY_CODE[Number(code)] || ''

const normalize =(status) => String(status || '').trim().toUpperCase().replace(/\s+/g, '_')

// CONFIRMED -> Confirmed, REQUEST_RETURN -> Return requested
export const statusLabel = (status) => {
    const key = normalize(status)
    if (key === 'REQUEST_RETURN') return 'Return requested'
    const text = key.replace(/_/g, ' ').toLowerCase()
    return text.charAt(0).toUpperCase() + text.slice(1)
}

export const statusTone = (status) => TONES[normalize(status)] || 'neutral'

// Index of the furthest normal step reached, or -1 when none matches.
export const reachedStepIndex = (history) => {
    if (!Array.isArray(history)) return -1
    return history.reduce((max, e) => Math.max(max, ORDER_STEPS.indexOf(normalize(e.status))), -1)
}

export const isOffTrack = (status) => ['CANCELLED', 'REQUEST_RETURN', 'RETURNED'].includes(normalize(status))
